/**
 * Normalises the raw `deliverablesCount` that rides on a Smart Calendar™ Gantt record into
 * the integer the Report(s) column renders and gates on.
 *
 * The single definition of that rule: it is consumed both by `CalendarReportsBadge` (which
 * decides between the count circle and the inert em-dash) and by `CalendarReportsCell` (which
 * decides whether to wrap the badge in a `Popover` at all). Those two MUST agree — a badge
 * showing a circle with no popover behind it, or an em-dash that is secretly clickable, are
 * both defects — so the rule lives here rather than being restated in each component.
 *
 * Anything that is not a finite number (`null`, `undefined`, `NaN`, `±Infinity`) collapses to
 * `0`. Finite values are truncated toward zero, so a fractional count becomes its integer part
 * and a negative count stays negative; callers treat any result `<= 0` as "no reports".
 * @param {number | null | undefined} count - Raw count as it arrives on the calendar payload.
 * @returns {number} The truncated count, or `0` when the input is not a finite number.
 */
export function resolveReportCount(count: number | null | undefined): number {
  return count != null && Number.isFinite(count) ? Math.trunc(count) : 0;
}
